import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const NAV = [
  { id: "inicio", label: "Inicio" },
  { id: "servicios", label: "Servicios" },
  { id: "equipo", label: "Equipo" },
  { id: "contacto", label: "Contacto" },
];

const LEGAL = [
  { to: "/politica-de-privacidad", label: "Política de privacidad" },
  { to: "/aviso-legal", label: "Aviso legal" },
];

const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-navy-900 text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-30 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20 relative">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Logo variant="light" />
            <p className="mt-6 text-sm text-white/65 leading-relaxed max-w-md">
              Gestión legal y técnica de embarcaciones abandonadas o con deuda en puertos y
              marinas.
            </p>
            <div className="mt-6 text-xs uppercase tracking-[0.2em] text-sky-300">
              portsdebt.es
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.22em] text-white/40 font-semibold">
              Navegación
            </h4>
            <ul className="mt-5 space-y-3">
              {NAV.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    data-testid={`footer-nav-${link.id}`}
                    className="text-sm text-white/75 hover:text-sky-300 transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.22em] text-white/40 font-semibold">
              Información legal
            </h4>
            <ul className="mt-5 space-y-3">
              {LEGAL.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-legal-${link.to.replace(/\//g, "")}`}
                    className="text-sm text-white/75 hover:text-sky-300 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-8 text-xs text-white/55 leading-relaxed border-t border-white/10 pt-6">
              <div className="font-medium text-white/80">PORT&rsquo;S DEBT COLLECTION S.L.</div>
              <div className="mt-1">CIF: B16935785</div>
              <div>C/ María de Molina nº 60</div>
              <div>28006 Madrid</div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-white/50">
            © {new Date().getFullYear()} PORT&rsquo;S COLLECTORS — Todos los derechos reservados.
          </div>
          <div className="text-xs text-white/50">
            Design by{" "}
            <a
              href="https://thefunnelbox.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-credit-funnelbox"
              className="text-sky-300 hover:text-white transition-colors underline-offset-4 hover:underline font-medium"
            >
              The Funnel Box
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
